<template>
    <div class="clearfix userCenterView">
        <div class="fr"><Bread :prop="bread" /></div>
        <Form ref="form"  />
        <FormMobile ref="formMobile" @submitSuccess="changeMobileSuccess"/> 
        <FormEmail ref="formEmail" @submitSuccess="changeEmailSuccess" />
        <NewEmail ref="NewEmail" @submitSuccess="changeEmailSuccess" />
        <div class="contentWrap fl"  style="width:100%">
            <div class="contentTitle">安全设置</div>
            <div class="content">
                <div class="item">
                    <div class="left">
                        <div class="title">登录密码</div>
                        <div>互联网存在被盗风险，建议您定期修改密码，以保证账户安全</div>
                    </div>
                    <div class="right">
                        <el-button class="edit" @click="changeForm()">修改</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="left">
                        <div class="title">手机号码</div>
                        <div>已绑定手机号：{{ formValue.mobile }}</div>
                        <div>可用于登录、密码找回、账户安全校验、接收通知</div>
                    </div>
                    <div class="right">
                        <el-button class="edit" @click="changeFormMobile()">修改</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="left">
                        <div class="title">电子邮箱</div>
                        <div v-if="formValue.email == ''">未绑定电子邮箱</div>
                        <div v-else>已绑定邮箱号：{{ formValue.email }}</div>
                        <div>可用于登录、密码找回、账户安全校检、接收通知</div>
                    </div>
                    <div class="right">
                        <el-button class="edit" v-if="formValue.email == ''" @click="changeFormNewEmail()">绑定</el-button>
                        <el-button class="edit" @click="changeFormEmail()" v-else>修改</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div style="width:500px;height:500px;">
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index.vue'
import { UserCenterService } from '../../../service/userCenter.service'
import Form from './formChangePassWord'
import FormMobile from './formChangeMobile'
import FormEmail from './formChangeMailNew'
import NewEmail from './formChangeMail'
export default {
    data() {
        return {
            bread: [{
                name: '用户中心',
                path: '/userCenter/index'
            },{
                name: '安全设置',
                path: '/userCenter/securitySetting'
            }],
            formValue: []
        }
    },
    components: {Bread,Form,FormMobile,FormEmail,NewEmail},
    methods: {
        async getList() {
            const data = await UserCenterService.getBaseInfo()
            this.formValue = JSON.parse(JSON.stringify(data))
        },
        changeForm() {
            this.$refs.form.open()
        },
        changeFormMobile() {
            this.$refs.formMobile.open(this.formValue.mobile)
        },
        changeFormEmail() {
            this.$refs.formEmail.open(this.formValue.email) 
        },
        changeFormNewEmail() {
            this.$refs.NewEmail.open() 
        },
        changeEmailSuccess(data) {
            this.formValue.email = data
        },
        changeMobileSuccess(data) {
            this.formValue.mobile = data
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
    .userCenterView{
        width: 935px;
        .content{
            padding: 40px 40px 50px 30px;
            border: 1px solid #e3e2e1;
            flex-direction: column;
            .el-input{
                width: 300px
            }
        }
    }
    .item{
        border: 1px solid #c1c0c0;
        margin-bottom: 35px;
        padding: 15px;
        display: flex;
        justify-content: space-between;
        height: 70px;
        .left{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title{
                font-weight: 700;
                font-size: 16px;
                color: #333;
            }
            div{
                color: #999;
            }
        }
        .right{
            line-height: 70px;
            .edit{
                padding: 10px 20px!important;
                background: #1d90d0;
                color: #fff;
                border-radius: 5px!important;
            }
        } 
    }
        
</style>